import MainLayout from '../layouts/main';
import ExamContainer from './container';

function ExamInfoPage() {
  return (
    <MainLayout title={EXAM_INFO_PAGE_TITLE}>
      <ExamContainer />
    </MainLayout>
  );
}

export const EXAM_INFO_PAGE_TITLE = 'توضیحات آزمون';

export default ExamInfoPage;
